import ReactMarkdown from 'react-markdown'
import { useMemoRef } from 'platform/react/hook'
import settings from '@tenant/settings'

/**
 * Markdown Text Element.
 *
 * By default, it ignores body and paragraph rules so that the inherited styles are preserved.
 *
 * @param {Object} props  to be passed to the underlying {@link ReactMarkdown} element.
 * @returns {JSX.Element}
 */
const Markdown = ({ value, children, ...props }) => (
  <ReactMarkdown
    disallowedElements={['p']} // We don't want paragraph tags for simple string
    unwrapDisallowed={true} // but we want the strings themselves
    components={{
      a: ({ href, children: c }) => (
        <a
          href={href}
          target={props.target || '_blank'}
          rel={'nofollow'}
          style={{
            textDecoration: settings.suppressUnderlineInHyperlinks
              ? 'none'
              : 'underline',
          }}
        >
          {c}
        </a>
      ),
      img: ({ alt, src, title }) => (
        <img
          alt={alt}
          src={src}
          title={title}
          style={{
            ...title === 'icon' && {
              width: 20,
              height: 20,
              verticalAlign: 'middle',
              marginBottom: '0.25em',
            },
            ...title === 'image' && {
              width: '100%',
              height: 'auto',
            },
          }}
        />
      ),
    }}
  >
    {value || children}
  </ReactMarkdown>
)

export default useMemoRef(Markdown, props => [props.children])
